import { ReactComponent as FlagIcon } from "./svg/gr-flag.svg";
import "../flag-icon.scss";

export const GRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
